export interface ReportObject {
  id: string;
  _id?: string; // Keep for backward compatibility
  reportId?: string;
  reportName: string;
  s3Key?: string;
  dateGenerated?: Date | string;
  description?:string,
  dateRange?: {
    startDate: Date | string;
    endDate: Date | string;
  };
  reportStatus:
    | 'Completed'
    | 'Processing'
    | 'Failed'
    | 'Pending'
    | 'processed'
    | 'completed'
    | 'processing'
    | 'failed'
    | 'pending';
  status?: 'completed' | 'processing' | 'failed' | 'pending'; // Keep for backward compatibility
  fileSize?: string;
  filePath?: string;
  companyId?: string;
  companyName?: string;
  createdBy?: string;
  isDownloading?: boolean;
  password?: string,
  showPassword?:boolean,
  icon?:string,
  class?:string,
  searchByDate?:any
}

export const reportStatusOptions = [
  { label: 'Completed', value: 'completed' },
  { label: 'Processing', value: 'processing' },
  { label: 'Failed', value: 'failed' },
  { label: 'Pending', value: 'pending' },
];
